module.exports = __webpack_public_path__ + "img/file_red.1116b971.svg";